export class UnexpectedCharacterException extends Error {}
